import { CsI18n } from "../../shared/csI18n/csI18n";
import { Card, ChoiceList, FormLayout, Heading, Layout, TextField } from "@shopify/polaris";
import Switch from "react-switch/index";
import ChoiceHelper from "../../helpers/ChoiceHelper";
import { CsValidation as V, CsValidationForm } from "../../shared/csValidationForm";
import HeadingHelper from "../../helpers/HeadingHelper";
import React from "react";

const SRCarrier = props => {
  const {
    validatorClass,
    windowWidth,
    carrierActive,
    shippingNational, shippingNationalOthers,
    shippingInternationalExpress, shippingInternationalExpressOthers,
    deliveryTime,
    handleChange, handleChoiceListChange,
  } = props;

  return (
    <Layout.AnnotatedSection
      title={CsI18n.t("shipping.annotate.title.carriers")}
      description={CsI18n.t('shipping.annotate.desc.carriers')}>
      <Layout.Section>
        <Card sectioned>
          <CsValidationForm name={validatorClass} realtime={true}>
            <FormLayout>
              <Heading element={'h3'}><CsI18n>Carriers</CsI18n></Heading>
              <p><CsI18n>I’d like to detail my national shipping carriers</CsI18n></p>
              <Switch
                className="react-switch"
                onChange={handleChange('carrierActive')}
                checked={carrierActive}
                uncheckedIcon={false}
                checkedIcon={false}
                aria-label={CsI18n.t("Carriers")}
              />
              {carrierActive && <>
                <FormLayout.Group>
                  <div className="ChoiceList-Multiple">
                    <ChoiceList
                      allowMultiple
                      title={CsI18n.t("National")}
                      choices={ChoiceHelper.choices(shippingNational)}
                      selected={ChoiceHelper.selected(shippingNational)}
                      onChange={handleChoiceListChange("shippingNational")}
                    />
                  </div>
                  <TextField
                    label={CsI18n.t("Other carriers")}
                    onChange={handleChange("shippingNationalOthers")}
                    value={shippingNationalOthers}
                    placeholder={CsI18n.t("Ex: GLS, Boxtal, Sendcloud")}
                    multiline
                  />
                </FormLayout.Group>
                <FormLayout.Group>
                  <div className="ChoiceList-Multiple">
                    <ChoiceList
                      allowMultiple
                      title={CsI18n.t("International & Express")}
                      choices={ChoiceHelper.choices(shippingInternationalExpress)}
                      selected={ChoiceHelper.selected(shippingInternationalExpress)}
                      onChange={handleChoiceListChange("shippingInternationalExpress")}
                    />
                  </div>
                  <TextField
                    label={CsI18n.t("Other carriers")}
                    onChange={handleChange("shippingInternationalExpressOthers")}
                    value={shippingInternationalExpressOthers}
                    placeholder={CsI18n.t("Ex: Correios, Sendcloud")}
                    multiline
                  />
                </FormLayout.Group>
              </>}

              <FormLayout.Group>
                <div className="input-small">
                  <V>
                    <TextField
                      label={HeadingHelper.ltt('Delivery time', 'shipping.explain.delivery_time')}
                      type="number" suffix={CsI18n.t('days')} min={1}
                      onChange={handleChange("deliveryTime")}
                      value={deliveryTime}
                    />
                    <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                    <V.Item rule="number" title={CsI18n.t("Number only.")} />
                    <V.Item rule="min" min={1} title={CsI18n.t("Too low number.")} />
                  </V>
                </div>
                {windowWidth >= 1200 &&
                <>
                  <div />
                  <div />
                  <div />
                </>}
              </FormLayout.Group>
            </FormLayout>
          </CsValidationForm>
        </Card>
      </Layout.Section>
    </Layout.AnnotatedSection>
  );
};

export default SRCarrier;
